import { apiLogin, apiLogout } from "../services/api";
import { clearSessionData, setSessionData } from "../utils/session";

export async function login(email, password) {
    if (!email || !password) {
        throw new Error("Debes ingresar un correo y una contrasena.");
    }

    const data = await apiLogin(email, password);
    const user = data?.user || data;
    const token = data?.token;

    if (!user) {
        throw new Error("No se pudo iniciar sesion.");
    }

    setSessionData(user, token);
    return user;
}

export async function logout() {
    await apiLogout();
    clearSessionData();
}
